import React, { useState } from 'react';
import { Activity, ShieldCheck, Heart, Radio, HardDrive, RefreshCw, Cpu, Server } from 'lucide-react';

const StatusPage = () => {
    const [lang, setLang] = useState(() => {
        try {
            const stored = localStorage.getItem('luxvono_geo_context');
            if (stored) {
                const parsed = JSON.parse(stored);
                if (parsed.language === 'ar') return 'ar';
            }
        } catch (_) {}
        return 'ar'; // Default to Arabic
    });

    const isRtl = lang === 'ar';

    const toggleLanguage = () => {
        setLang(prev => (prev === 'ar' ? 'en' : 'ar'));
    };

    const t = {
        title: { ar: "حالة نظام لوكسفونو التشغيلية", en: "LuxVono System Status" },
        subtitle: { ar: "مراقبة مستمرة وسريعة لأداء واستقرار الخوادم والبنية التحتية لمنصة لوكسفونو.", en: "Live operational uptime and status diagnostic tracking for the LuxVono infrastructure." },
        overall: { ar: "جميع الأنظمة تعمل بكفاءة تامة", en: "All Core Systems Operational" },
        diagnostics: { ar: "تشخيصات الأنظمة الفردية", en: "Subsystem Status Breakdown" },
        sys1: { ar: "بوابة الربط والواجهة الخلفية (API Gateway)", en: "Central API Gateway & Routing" },
        sys2: { ar: "قاعدة البيانات المركزية الآمنة (Secure Core DB)", en: "Secure PostgreSQL Cluster" },
        sys3: { ar: "خادم اتصالات الوقت الفعلي (WebSocket WebSocket)", en: "Realtime WebSocket Node" },
        sys4: { ar: "خوادم تخزين وبث ملفات الوسائط (Media Storage & CDN)", en: "Static Media Storage & Video CDN" },
        active: { ar: "نشط ويعمل", en: "OPERATIONAL" },
        refreshed: { ar: "تم التحديث تلقائياً للتو", en: "Uptime verified just now" }
    };

    return (
        <div 
            className="status-page-root"
            dir={isRtl ? 'rtl' : 'ltr'}
            style={{
                background: '#08080C',
                color: '#FFFFFF',
                minHeight: '100vh',
                fontFamily: "'Outfit', 'Inter', 'Noto Sans Arabic', sans-serif",
                paddingBottom: '80px',
                position: 'relative',
                overflowX: 'hidden'
            }}
        >
            <style dangerouslySetInnerHTML={{__html: `
                .status-page-root {
                    background: radial-gradient(circle at 50% 0%, #111B24 0%, #08080c 60%) !important;
                }
                .status-glow {
                    position: absolute;
                    width: 450px;
                    height: 450px;
                    background: radial-gradient(circle, rgba(74,222,128,0.06) 0%, rgba(74,222,128,0) 70%);
                    top: -50px;
                    left: 20%;
                    filter: blur(60px);
                    pointer-events: none;
                }
                .stat-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 24px 8%;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
                    background: rgba(8, 8, 12, 0.4);
                    backdrop-filter: blur(20px);
                }
                .stat-logo {
                    font-size: 24px;
                    font-weight: 700;
                    letter-spacing: 5px;
                    background: linear-gradient(135deg, #FFFFFF 30%, #C5A880 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                .stat-lang-btn {
                    background: rgba(255, 255, 255, 0.03);
                    border: 1px solid rgba(255, 255, 255, 0.08);
                    border-radius: 40px;
                    padding: 8px 16px;
                    color: #FFFFFF;
                    font-size: 13px;
                    font-weight: 500;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    transition: all 0.3s ease;
                }
                .stat-lang-btn:hover {
                    background: rgba(74, 222, 128, 0.1);
                    border-color: rgba(74, 222, 128, 0.3);
                }
                .stat-hero {
                    max-width: 900px;
                    margin: 60px auto 40px auto;
                    text-align: center;
                    padding: 0 20px;
                }
                .stat-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    background: rgba(74, 222, 128, 0.08);
                    border: 1px solid rgba(74, 222, 128, 0.25);
                    color: #4ADE80;
                    padding: 6px 18px;
                    border-radius: 50px;
                    font-size: 12px;
                    font-weight: 700;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                    margin-bottom: 24px;
                }
                .stat-badge-dot {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: #4ADE80;
                    animation: pulse 2s infinite;
                }
                .stat-title {
                    font-size: clamp(30px, 5vw, 46px);
                    font-weight: 800;
                    line-height: 1.25;
                    margin-bottom: 20px;
                }
                .stat-subtitle {
                    font-size: 15px;
                    color: #A3A3A3;
                    line-height: 1.6;
                    max-width: 700px;
                    margin: 0 auto;
                }
                .stat-container {
                    max-width: 800px;
                    margin: 0 auto;
                    padding: 0 6%;
                }
                .stat-overall-card {
                    background: rgba(22, 101, 52, 0.08);
                    border: 1px solid rgba(34, 197, 94, 0.2);
                    border-radius: 20px;
                    padding: 24px;
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    margin-bottom: 40px;
                    color: #4ade80;
                }
                .stat-list {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                }
                .stat-item {
                    background: rgba(13, 14, 22, 0.65);
                    border: 1px solid rgba(255, 255, 255, 0.05);
                    border-radius: 18px;
                    padding: 24px;
                    backdrop-filter: blur(25px);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    transition: all 0.3s ease;
                }
                .stat-item:hover {
                    border-color: rgba(74, 222, 128, 0.2);
                    transform: translateY(-2px);
                }
                @media (max-width: 550px) {
                    .stat-item {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 20px;
                    }
                }
                .stat-item-left {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                }
                .stat-item-icon {
                    background: rgba(255, 255, 255, 0.03);
                    border: 1px solid rgba(255, 255, 255, 0.06);
                    border-radius: 12px;
                    padding: 10px;
                    color: #C5A880;
                    display: flex;
                }
                .stat-item-name {
                    font-size: 15px;
                    font-weight: 700;
                    color: #FFFFFF;
                    margin-bottom: 4px;
                }
                .stat-item-sub {
                    font-size: 12px;
                    color: #737373;
                }
                .stat-item-right {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    background: rgba(74, 222, 128, 0.06);
                    border: 1px solid rgba(74, 222, 128, 0.15);
                    padding: 6px 14px;
                    border-radius: 30px;
                    color: #4ade80;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                }
                .stat-footer {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    margin-top: 40px;
                    font-size: 13px;
                    color: #525252;
                }
                .stat-footer-icon {
                    animation: spin 3s linear infinite;
                }
            `}} />

            <div className="status-glow"></div>

            <header className="stat-header">
                <div className="stat-logo">LUXVONO</div>
                <button className="stat-lang-btn" onClick={toggleLanguage}>
                    <Activity size={14} style={{ color: '#4ade80' }} />
                    <span>{isRtl ? 'English' : 'العربية'}</span>
                </button>
            </header>

            <main className="stat-container">
                <div className="stat-hero">
                    <span className="stat-badge">
                        <span className="stat-badge-dot"></span>
                        {isRtl ? "مراقبة الأنظمة الحية" : "LIVE INFRASTRUCTURE FEED"}
                    </span>
                    <h1 className="stat-title">{isRtl ? t.title.ar : t.title.en}</h1>
                    <p className="stat-subtitle">{isRtl ? t.subtitle.ar : t.subtitle.en}</p>
                </div>

                <div className="stat-overall-card">
                    <ShieldCheck size={26} />
                    <span style={{ fontWeight: '700', fontSize: '15px' }}>{isRtl ? t.overall.ar : t.overall.en}</span>
                </div>

                <h2 style={{ fontSize: '18px', fontWeight: '800', marginBottom: '24px', color: '#E5E5E5' }}>
                    {isRtl ? t.diagnostics.ar : t.diagnostics.en}
                </h2>

                <div className="stat-list">
                    {/* Item 1 */}
                    <div className="stat-item">
                        <div className="stat-item-left">
                            <div className="stat-item-icon"><Server size={18} /></div>
                            <div>
                                <h3 className="stat-item-name">{isRtl ? t.sys1.ar : t.sys1.en}</h3>
                                <span className="stat-item-sub">Ping: 12ms • Status: 200 OK</span>
                            </div>
                        </div>
                        <div className="stat-item-right">
                            <span className="stat-badge-dot" style={{ margin: 0 }}></span>
                            <span>{isRtl ? t.active.ar : t.active.en}</span>
                        </div>
                    </div>

                    {/* Item 2 */}
                    <div className="stat-item">
                        <div className="stat-item-left">
                            <div className="stat-item-icon"><Cpu size={18} /></div>
                            <div>
                                <h3 className="stat-item-name">{isRtl ? t.sys2.ar : t.sys2.en}</h3>
                                <span className="stat-item-sub">Uptime: 99.98% • Active Connections: 140</span>
                            </div>
                        </div>
                        <div className="stat-item-right">
                            <span className="stat-badge-dot" style={{ margin: 0 }}></span>
                            <span>{isRtl ? t.active.ar : t.active.en}</span>
                        </div>
                    </div>

                    {/* Item 3 */}
                    <div className="stat-item">
                        <div className="stat-item-left">
                            <div className="stat-item-icon"><Radio size={18} /></div>
                            <div>
                                <h3 className="stat-item-name">{isRtl ? t.sys3.ar : t.sys3.en}</h3>
                                <span className="stat-item-sub">Uptime: 100% • Load: 0.15</span>
                            </div>
                        </div>
                        <div className="stat-item-right">
                            <span className="stat-badge-dot" style={{ margin: 0 }}></span>
                            <span>{isRtl ? t.active.ar : t.active.en}</span>
                        </div>
                    </div>

                    {/* Item 4 */}
                    <div className="stat-item">
                        <div className="stat-item-left">
                            <div className="stat-item-icon"><HardDrive size={18} /></div>
                            <div>
                                <h3 className="stat-item-name">{isRtl ? t.sys4.ar : t.sys4.en}</h3>
                                <span className="stat-item-sub">Bandwidth: 1.2Gbps • Cache Hit Rate: 94.2%</span>
                            </div>
                        </div>
                        <div className="stat-item-right">
                            <span className="stat-badge-dot" style={{ margin: 0 }}></span>
                            <span>{isRtl ? t.active.ar : t.active.en}</span>
                        </div>
                    </div>
                </div>

                <div className="stat-footer">
                    <RefreshCw size={12} className="stat-footer-icon" />
                    <span>{isRtl ? t.refreshed.ar : t.refreshed.en}</span>
                </div>
            </main>
        </div>
    );
};

export default StatusPage;
